/* eslint-disable jsx-a11y/click-events-have-key-events */
import clsx from 'clsx'
import { FC, useState } from 'react'
import { htmlReactParse } from 'shared-code/html'
import RWButton from '../buttons/RWButton'
import SocialIcon from '../service/SocialIcon'
import AppImage from '../ui/AppImage'
import styles from './AboutExpert.module.css'
import { BasicStyledComponent, DSAboutExpert } from 'shared-definitions/types'

const AboutExpert: FC<DSAboutExpert & BasicStyledComponent> = ({
  className,
  label,
  teamMeber,
  profileLabel,
}) => {
  const [collapsed, setCollapsed] = useState(true)

  return (
    <div className={clsx(styles.container, className)}>
      {label && <div className={styles.label}>{label}</div>}
      {teamMeber.image && (
        <AppImage layout="raw" image={teamMeber.image} className={styles.image} sizes={48} />
      )}
      <div className={styles.name}>{teamMeber.name}</div>
      {teamMeber.description && (
        <div
          onClick={() => setCollapsed(false)}
          role={!collapsed ? undefined : 'button'}
          tabIndex={!collapsed ? undefined : 0}
          className={clsx(styles.description, {
            [styles.descriptionCollapsed]: collapsed,
          })}
        >
          {htmlReactParse(teamMeber.description)}
        </div>
      )}
      <div className={styles.bottomLine}>
        {teamMeber.socials.map((icon, iconIndex) => (
          <RWButton key={iconIndex} pLink={icon.pLink} variant="tertiary" size="small">
            <SocialIcon className={styles.socialIcon} icon={icon.icon} />
          </RWButton>
        ))}
        <RWButton pLink={teamMeber.pLink} variant="tertiary" size="small">
          {profileLabel}
        </RWButton>
      </div>
    </div>
  )
}

export default AboutExpert
